import { observer } from "mobx-react-lite";

import { Select } from "../../fields/select";
import { type EnumValues } from "../../fields/utils";

export const CellSelect = observer(function CellSelect<
  T extends object,
  V extends string | number,
>({
  model,
  attr,
  values,
  listTitle,
  onChange,
  disabled,
  required,
}: {
  model: T;
  attr: keyof T;
  values: EnumValues<V>;
  listTitle?: string;
  onChange?: (newValue: V) => void;
  disabled?: boolean;
  required?: boolean;
}) {
  if (disabled) {
    return <>{model[attr]}</>;
  }

  return (
    <Select
      attr={attr}
      model={model}
      values={values}
      listTitle={listTitle}
      onChange={onChange}
      required={required}
    />
  );
});
